<template>
    <div>
        <ProjectProgressBar
            :percentage="percentage">
            <template #label>
                <NiceDecimalNumber :number="formattedSum" />
                <CurrencySymbol :currency-code="currency" />
                <small>
                    /
                    <NiceDecimalNumber :number="donationGoal" />
                    <CurrencySymbol :currency-code="currency" />
                </small>
            </template>
        </ProjectProgressBar>
        <div class="m-2">
            <small v-if="formattedSum <= 0">
                {{ $t('iFrame.progress.beTheFirst') }}
            </small>
            <small v-if="difference">
                {{ $t('iFrame.progress.stillMissing') }}
                <strong>
                    <NiceDecimalNumber :number="difference" />
                    <CurrencySymbol :currency-code="currency" />
                </strong>
                {{ $t('iFrame.progress.pleaseHelpDonating') }}
            </small>
            <small v-else>
                {{ $t('iFrame.progress.achievedGoal') }}
            </small>
        </div>
    </div>
</template>

<script>

import ProjectProgressBar from "./ProjectProgressBar";

export default {
    name: "ProjectDonationProgress",
    components: {ProjectProgressBar},
    props: {
        donationGoal: {
            type: Number,
            required: true
        },
        donationSum: {
            type: [Number, String]
        },
        currency: {
            type: String,
            required: true
        }
    },
    computed: {
        percentage() {
            return Math.min(this.formattedSum / (Math.max(this.donationGoal, 1)) * 100, 100)
        },
        difference() {
            if (this.formattedSum >= this.donationGoal) return null
            return this.donationGoal - this.formattedSum
        },
        formattedSum() {
            if (!this.donationSum) return 0
            return parseFloat(this.donationSum) || 0
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
